import { rei } from "@/services/api"
import OrdemServico from "../../entities/OrdemServico/OrdemServico"

class OrdensServicoService {
  static async getOSByResgitroId (registro_id) {
    let ordensServico = await rei.get(`ordem-servico?registro_id=${registro_id}, , { timeout: 10000 }`)
    .then(res => res.data.data)
    let ordensServicoInstances = ordensServico.map((os) => new OrdemServico(os))
    return ordensServicoInstances
  }

  static async getOS (params = null, registroId = null) {
    let url = 'ordem-servico'

    if (registroId) {
      url += `?registro_id=${registroId}`
    }

    if (params) {
      const query = []

      if (params.identificadorSolicitante) {
        query.push(`identificadorSolicitante=${params.identificadorSolicitante}`)
      }

      if (params.data_cumprida) {
        query.push(`data_cumprida=${params.data_cumprida}`)
      }

      if (params.page) {
        query.push(`page=${params.page}`)
      }

      if (params.perPage) {
        query.push(`perPage=${params.perPage}`)
      }

      if (params.status_selos) {
        query.push(`status_selos=${params.status_selos}`)
      }

      if (query.length) {
        url += `${registroId ? '&' : '?'}${query.join('&')}`
      }
    }
    
    let ordensServico = await rei.get(url).then(res => registroId ? res.data.data : res.data)
    ordensServico.data = ordensServico.data ? ordensServico.data.map((os) => new OrdemServico(os)) : ordensServico.map((os) => new OrdemServico(os))
    return ordensServico
  }

  static async getOsBySelo (params) {
    let url = 'selo'

    if (params) {
      const queryParams = []

      for (const chave in params) {
        if (params.hasOwnProperty(chave) && params[chave] !== null && params[chave] !== undefined) {
          const valor = encodeURIComponent(params[chave])
          queryParams.push(`${chave}=${valor}`)
        }
      }

      // Verifica se há parâmetros de consulta para adicionar à URL
      if (queryParams.length > 0) {
        // Concatena os parâmetros de consulta à URL
        url += `?${queryParams.join('&')}`
      }

      const ordensServicos = await rei.get(url)
      return ordensServicos
    }
  }

  static async showOS (ordemServicoId = null) {
    if (!ordemServicoId) return
    const ordensServico = await  rei.get(`ordem-servico/${ordemServicoId}`, { timeout: 10000 })
      .then(res => res.data)
    return new OrdemServico(ordensServico)
  }

  static getOsToCaixa () {
    return rei.get(`ordens-servicos-frente-caixa-servico`, { timeout: 5000 })
      .then(res => res.data)
  }

  static getOsToCaixa () {
    return rei.get(`ordens-servicos-frente-caixa-servico`, { timeout: 5000 })
      .then(res => res.data)
  }

  static storeOS (ordem) {
    return rei.post(`ordem-servico`, ordem, { timeout: 10000 })
      .then(res => res.data)
  }

  static updateOS (ordem, id) {
    return rei.put(`ordem-servico/${id}`, ordem, { timeout: 10000 }).then(res => res.data)
  }

  static destroyOS (id) {
    return rei.delete(`ordem-servico/${id}`, { timeout: 10000 }).then(res => res.data)
  }

  static storeOsItem (ordem_item) {
    if (!ordem_item.averbacao) {
      ordem_item.averbacao = 0
    }
    
    return rei.post(`ordem-servico-item`, ordem_item, { timeout: 10000 }).then(res => res.data)
  }

  static updateOsItem (ordem_item, id) {
    if (!ordem_item.averbacao) {
      ordem_item.averbacao = 0
    }
    return rei.put(`ordem-servico-item/${id}`, ordem_item, { timeout: 10000 }).then(res => res.data)
  }

  static destroyOsItem (id) {
    return rei.delete(`ordem-servico-item/${id}`).then(res => res.data)
  }

  static getOsCanceladas (params) {
    return rei.post('ordens-servicos-canceladas', params, { timeout: 10000}).then(res => res.data)
  }
}

export default OrdensServicoService
